// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SearchBar.css */
.search-bar {
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .search-bar input {
    border: none;
    outline: none;
    width: 100%;
    padding: 8px;
    font-size: 13px;
  }
  
  .search-bar button {
    background-color: #4AAE9B;
    color: #ffffff;
    border: none;
    padding: 8px 16px;
    border-radius: 35px;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
    width: 100%;
    font-family: "Lato";
}
  
.search-bar button:hover {
  background-color: #A8C9B0;
  color: #ffffff;
}
  `, "",{"version":3,"sources":["webpack://./src/Pages/Home/Pages/SubscriptionsPage/Subscriptions/Sidebar/SearchBar/SearchBarHome.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,6CAA6C;IAC7C,WAAW;IACX,mBAAmB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":["/* SearchBar.css */\n.search-bar {\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 10px;\n    padding: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n  \n  .search-bar input {\n    border: none;\n    outline: none;\n    width: 100%;\n    padding: 8px;\n    font-size: 13px;\n  }\n  \n  .search-bar button {\n    background-color: #4AAE9B;\n    color: #ffffff;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 35px;\n    cursor: pointer;\n    transition: background-color 0.3s ease-in-out;\n    width: 100%;\n    font-family: \"Lato\";\n}\n  \n.search-bar button:hover {\n  background-color: #A8C9B0;\n  color: #ffffff;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
